export default __webpack_public_path__ + "static/bushbuck-bg-09e07417c7d2d49a3145fe50ef8148af.png";